import RackOscillator from './oscillator/RackOscillator.js';
import Tone from 'tone';
import MasterPitchEnvelope from './MasterPitchEnvelope.js';

export default superclass => class extends superclass  {
    setupOscillators() {
        // by default have 2 oscillators
        this.pitchEnvelope = new MasterPitchEnvelope(
            this.sequencerEngine, this.mixSession, this.context);

        this.pitchEnvelope.name = "Pitch Envelope";
        
        this.oscillatorNodes = [
            this.createNewOscillator(true, "C"),
            this.createNewOscillator(true, "A"),
            this.createNewOscillator(true, "B1"),
            this.createNewOscillator(true, "B2")];

        this.oscillators[0].enabled = true;
        this.oscillators[1].enabled = true;
        this.oscillators[2].enabled = true;
        this.oscillators[3].enabled = true;
    }

    get carrierOscillator() {
        if (!this.oscillatorNodes) {
            return undefined;
        }
        return this.oscillatorNodes[0];
    }

    get modulatorOscillators() {
        if (!this.oscillatorNodes) {
            return undefined;
        }
        return this.oscillators.slice(1);
    }

    get oscillators() {
        if (!this.oscillatorNodes) {
            return [];
        }
        return this.oscillatorNodes.filter(x => x.enabled);
    }

    // returns the ith oscillator of the synth
    getOscillator(i) {
        if (!this.oscillatorNodes) {
            return [];
        }
        return this.oscillatorNodes[i];
    }

    // returns a newly instantiated oscillator
    createNewOscillator(create=true, name='A') {
        return new RackOscillator(
            this.sequencerEngine,
            this.mixSession,
            this.context,
            this.pitchEnvelope.envelope,
            create,
            name,
            this.track,
            this);
    }
}
